<template>
<div>
<div v-if="isLoading" class="loading">Loading&#8230;</div> 

<!-- END HEADER data_student -->

<!-- <div class="columns is-multiline is-gapless" style="margin-top:-1em;"> -->
 
<div id="myModalCourse" class="modal">
  <div class="modal-background" @click="cancel_course()"></div>
  <div class="modal-content" style="width: 50%">
  <div  class="box has-background-white">

<div class="columns is-multiline is-centered" style="padding:.5em;">

<div class="column is-12 is-uppercase is-size-6 has-text-weight-bold" style="margin-bottom:-.8em;">ADD COURSE : {{stud_name}} </div>


<div class="column is-4 is-size-7 has-text-weight-bold has-text-info" style="margin-bottom:-1.8em;">SESSION-ANNEE</div>
<div class="column is-4 is-size-7 has-text-weight-bold has-text-info" style="margin-bottom:-1.8em;">GROUP</div>
<!-- <div class="column is-4 is-size-7 has-text-weight-bold has-text-info" style="margin-bottom:-1.8em;">SEARCH</div> -->
<div class="column is-4" style="margin-bottom:-1.8em;"></div>

    <div class="column is-4">
        <div class="select  is-fullwidth has-text-weight-bold">
            <select @change="change_sess()"  class="has-text-weight-bold has-text-dark" v-model="selected_session">
                    <option value=""></option>
                    <option v-for="(choice,index) in data_sessions" :key="index" :value="choice">{{ choice }}</option>
            </select>
        </div>
    </div>
    <div class="column is-4">
        <div class="select  is-fullwidth has-text-weight-bold">
            <select  @change="change_grp()" class="has-text-weight-bold has-text-dark" v-model="selected_group">
                    <option value=""></option>
                    <option v-for="(choice,index) in data_groups" :key="index" :value="choice.group_CODE">{{ choice.group_CODE }}</option>
            </select>
        </div>
    </div>
    <div class="column is-4"></div>
    <!-- <div class="column is-4">
        <p class="control has-icons-left"><input  v-model="course_search" class="input is-uppercase is-fullwidth has-text-weight-bold" type="text" placeholder="...."><span class="icon is-small is-left"><i class="fas fa-search" aria-hidden="true"></i></span></p>
    </div> -->

            <div v-if="show_add_course" class="column is-12" style="margin-top:1em;">
                    <CourseNew ref="courseNew"
                    @emit_course_add="emit_course_add"
                    @emit_course_remove="emit_course_remove"
                    :studentID="studentID"></CourseNew>
            </div>

  <div class="column is-2 has-text-centered"> <button @click="cancel_course()"  class="button is-fullwidth has-background-danger has-text-black"><span class="icon is-small has-text-left"><i class="fas fa-window-close"></i></span>     </button> </div>
  <div class="column is-6 has-text-centered"> </div>
  <div class="column is-4 has-text-centered"> <button @click="insert_new_courses()"  v-if="selected_groups.length > 0 " class="button is-fullwidth has-background-success has-text-black"><span class="icon is-small has-text-left"><i class="fas fa-save"></i></span>     </button> </div>

</div>
<!-- BOX -->

</div>
</div>
</div>
<!-- END MODAL -->






<div class="columns is-gapless is-multiline is-centered" style="margin-top:-.4em;">



<!-- !!!!!!!!! TOGGLE BETWEEN COURSE LIST AND ADD (/DELETE) !!!!!!!!!!!!!!!  -->

    <div class="column is-1 has-tooltip-right has-tooltip-success" data-tooltip="ADD COURSE">
        <button @click="add_course()"  class="button is-fullwidth has-background-success has-text-black"><span class="icon is-small has-text-left"><i class="fas fa-plus"></i></span>     </button> 
    </div>
    <div class="column is-11"></div>

    <div class="column is-10" style="" v-for ="(grp, index) in data_student" :key="index">
        <CourseList :data="grp" @emit_course_change="emit_course_change">   </CourseList>
    </div>









</div>




<!-- <div class="column is-12">
 <CourseDetails v-if="comp_grp_group" :student="comp_grp_student" :session="comp_grp_session" :grpID_IN="comp_grp_group" :icr="comp_grp_icr" :rcs="comp_grp_rcs" 
:key="randomKey()" @emit_load_start="emit_load_start" @emit_load_end="emit_load_end"></CourseDetails>
</div>

<div style="margin-bottom:0em;padding:4px;border-bottom:1px solid gray;border-left:1px solid gray;border-right:1px solid gray;" 
class="columns is-multiline">
<div class="column is-3" v-for ="(data, index) in data_program" :key="index">

<CourseList class="box has-background-grey-light" :data="data" :data_student="data_student" :data_transmission="data_transmission"  
@emit_list_click="emit_list_click"
:key="randomKey()" ></CourseList>

</div>
</div>
</div>  -->
<!-- END MAIN COLUMN -->
<!-- END CONTAINER COLUMN 4 -->






<!-- <div class="columns is-multiline is-mobile">
    <div class="column is-3" v-for ="(grp, ind_grp) in stud_grps" :key="ind_grp">

<div class="columns is-multiline is-gapless" style="margin-bottom:0em;">
<div class="column colBorder is-2 has-text-centered has-text-weight-bold has-background-grey-dark has-text-white">{{grp.group_SESS}}{{grp.group_ANN}}</div>
<div class="column colBorder is-4 has-text-centered has-text-weight-bold is-size-7 has-text-info">{{grp.cour_CODE}}</div>
<div class="column colBorder is-2 has-text-centered">{{grp.cs_MARK}}</div>
<div v-if="grp.cs_REMARK === 'EC'" class="column colBorder is-2 has-text-centered has-text-white has-background-danger">{{grp.cs_REMARK}}</div>
<div v-else class="column colBorder is-2 has-text-centered">{{grp.cs_REMARK}}</div>
<div class="column colBorder is-2 has-text-centered">{{grp.group_AVG}}</div>
</div>

            <div v-for ="(pond, ind_pond) in stud_ponds" :key="ind_pond">  
                <div v-if="grp.group_ID == pond.group_ID"  class="columns is-multiline is-gapless">
                    <div class="column colBorder is-8 has-background-white-ter">&nbsp;{{pond.ponderation_Desc}}</div>
                    <div class="column colBorder is-2 has-text-centered">{{pond.note_NOTE}}</div>
                    <div class="column colBorder is-2 has-text-centered">{{pond.ponderation_AVG}}</div>
                </div>
            </div>   

    </div>

<div class="column is-12 divBreak"></div> 
</div> --> <!-- bottom border -->

<!-- </div> -->
</div>
</template>


<script>
import axios from 'axios';
import moment from 'moment';

//import myUtilities from "@/assets/js/utilities.js";

import Calendar from '@/components/Comp_Calendar'
 
import CourseList  from '@/components/Comp_Student_Courses_List';
import CourseNew  from '@/components/Comp_Student_Courses_New';


// import CourseDetails  from '@/components/Comp_Student_Courses_Details';


export default {
    props: [ 'studentID' ],
    components: { CourseList, CourseNew, Calendar },
        data() {
            return {
                isLoading:false,
                stud_course_data:[],
                stud_grps:[], // HOLDS STUDENTS GROUPS
                stud_ponds:[], // 
                stud_notes:[], // 

                // ---- FOR LOADING COURSE DETAILS ----
                comp_grp_session: '', // SESSION -- for display
                comp_grp_group:'', // id of group 
                comp_grp_student:'' , // id of student
                comp_grp_icr:'' ,
                comp_grp_rcs:'' ,


                data_program:[],
                
                data_courses:'',
                data_transmission:[],


// FOR ADDING NEW COURSES !
data_groups:[],
data_sessions:[],
selected_session:'',
selected_group:'',
selected_groups:[],

show_add_course : false ,

course_view : 'LIST',

course_search:'',

mod_program:false,

data_schedule:[],
data_programs:[], // HOLDS LIST OF PROGRAMS
data_student:[],

stud_name:'',

config: { // FLATPICKER
    altFormat: "M j, Y",
    altInput: true
},
                
            }
        },


created() {



  
     
// GET DISTINCT GROUPS -- NEW COURSE
var dt = moment().subtract(90, 'days').format('YYYY-MM-DD') 
var sql =  "SELECT DISTINCT group_CODE FROM myMEQ_GROUP WHERE group_datEND > '" + dt +  "' ORDER BY group_CODE"
console.log(sql)
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
.then(res => { this.data_groups = res.data
        var i;
        for (i = 18; i < 22; i++) {
            this.data_sessions.push('H-'+ i)
            this.data_sessions.push('E-'+ i)
            this.data_sessions.push('A-'+ i)
        }    
    this.load_data()     
 }) 




    
}, //END CREATED

methods: {

emit_course_change:function() {
    // CALLED WHEN DELETING A COURSE!
    this.load_data()
},


load_data:function() {

    this.isLoading=true;
    var sql;


// GET STUDENT INFO
sql = "SELECT MyMEQ_STUDENT.student_ID AS studID, MyMEQ_STUDENT.student_lNAME + ', ' + MyMEQ_STUDENT.student_fNAME AS nom, MyMEQ_GROUP.group_ID AS grpID, *,MyMEQ_STAFF.staff_Prenom + ' ' + MyMEQ_STAFF.staff_Nom AS prof1, MyMEQ_STAFF_1.staff_Prenom + ' ' + MyMEQ_STAFF_1.staff_Nom AS prof2 FROM MyMEQ_STUDENT LEFT OUTER JOIN  MyMEQ_COURSESTUDENT ON MyMEQ_STUDENT.student_ID = MyMEQ_COURSESTUDENT.student_ID LEFT OUTER JOIN  MyMEQ_GROUP ON MyMEQ_COURSESTUDENT.group_ID = MyMEQ_GROUP.group_ID LEFT OUTER JOIN MyMEQ_COUR ON MyMEQ_GROUP.cour_ID = MyMEQ_COUR.cour_ID LEFT OUTER JOIN MyMEQ_STAFF ON MyMEQ_GROUP.staff_ID_1 = MyMEQ_STAFF.staff_ID LEFT OUTER JOIN MyMEQ_STAFF AS MyMEQ_STAFF_1 ON MyMEQ_GROUP.staff_ID_2 = MyMEQ_STAFF_1.staff_ID "
sql += " WHERE MyMEQ_STUDENT.student_ID = " + this.studentID + " ORDER BY group_datEND DESC"

axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
.then(res => {
    this.data_student = res.data
    this.stud_name = this.data_student[0].nom

sql = `SELECT myMEQ_SCHEDULE_MAIN.*,myMEQ_SCHEDULE_ROOM.schedRoom_DESC,schedRoom_CAMPUS,  MyMEQ_STAFF.staff_Prenom + ' ' + MyMEQ_STAFF.staff_Nom AS prof , DATEADD(day, 1, schedMain_date) AS DateAdd
 ,MyMEQ_COUR.cour_TITRE_F FROM myMEQ_SCHEDULE_MAIN LEFT OUTER JOIN myMEQ_SCHEDULE_ROOM ON myMEQ_SCHEDULE_MAIN.schedRoom_ID = myMEQ_SCHEDULE_ROOM.schedRoom_ID 
 LEFT OUTER JOIN  MyMEQ_STAFF ON myMEQ_SCHEDULE_MAIN.staff_ID = MyMEQ_STAFF.staff_ID  
 LEFT OUTER JOIN MyMEQ_COURSESTUDENT ON myMEQ_SCHEDULE_MAIN.group_ID = MyMEQ_COURSESTUDENT.group_ID 
 LEFT OUTER JOIN MyMEQ_GROUP ON MyMEQ_COURSESTUDENT.group_ID = MyMEQ_GROUP.group_ID 
 LEFT OUTER JOIN MyMEQ_COUR ON MyMEQ_GROUP.cour_ID = MyMEQ_COUR.cour_ID 
 WHERE student_ID = ` + this.studentID + `   ORDER BY schedMain_AmPmSoir`

console.log(sql)

axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
.then(res => {

this.data_schedule = [];
var i;
for (i = 0; i < res.data.length; i++) {


var desc = "<div class='columns is-gapless is-multiline'>"
desc += "<div class='column is-12 is-size-7 has-text-weight-bold'> " + res.data[i].cour_TITRE_F + " </div>"
desc += "<div class='column is-12' style='margin-top:-.4em;'> " + res.data[i].prof + " </div>"
desc += "<div class='column is-9'> " + res.data[i].schedRoom_CAMPUS + " </div>"
desc += "<div class='column is-3 is-size-5 has-text-weight-bold has-text-centered' style='margin-top:-.2em;'> " + res.data[i].schedRoom_DESC  + "</div>"
desc += "<div>"


    this.data_schedule.push( 
    { 
        id:res.data[i].schedMain_ID,
        course:res.data[i].cour_TITRE_F,
        title: desc, //res.data[i].schedMain_AmPmSoir + " : " + res.data[i].schedMain_CODE_COUR + " : " + res.data[i].schedMain_CODE_PROF,
        details: 'COUR : ' + res.data[i].schedMain_CODE_COUR + '<br>' + 'PROF : ' + res.data[i].prof + '<br>' + 'TIME : ' + res.data[i].schedMain_AmPmSoir + '<br>SALLE : ' + res.data[i].schedRoom_DESC + '<br><b>' + res.data[i].schedRoom_CAMPUS + '</b>',
        date: moment(res.data[i].DateAdd).format('YYYY-MM-DD'),
        open: false,
        class:'my-event',
        color: res.data[i].schedMain_COLOUR,
        hour:res.data[i].schedMain_AmPmSoir
    })
} // END FOR




    // GET PROGRAMS
    sql = "SELECT * FROM MyMEQ_PROGRAM WHERE prog_ACTIVE = 1 ORDER BY prog_TITRE_F"
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
    .then(res => { 
        this.data_programs = res.data
        this.isLoading=false;  

})
})   
}) 

},


    //this.student_courses()
    //this.load_student_summary()
    //this.comp_grp_student = this.studentID // FOR COMPONENT



insert_new_courses:function() {
 
 var sql = ""

var i;
for (i = 0; i < this.selected_groups.length; i++) {
    // if (this.selected_groups[i].is_selected == true) {
    sql += "INSERT INTO MyMEQ_COURSESTUDENT (student_ID, group_ID, cs_groupCode, cs_blnActive, cs_blnDoneBCU,cs_REMARK) VALUES ("
    sql += this.studentID + "," + this.selected_groups[i].grpID + ",'" + this.selected_groups[i].grpCODE + "',1,0,'');" 

    // this.data_courses[i].is_saved = true
    // } 
}
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
    .then(res => { 
        this.load_data() 
        document.querySelector('#myModalCourse').classList.remove('is-active');
    })
},




emit_course_add:function(grpID, grpCODE) {
    this.selected_groups.push({grpID:grpID , grpCODE:grpCODE })
},
emit_course_remove:function(grpID) {
    var indx = this.selected_groups.findIndex(x => x.grpID == grpID)
    this.selected_groups.splice(indx,1)
},


change_sess:function(){
    this.selected_group = ''
    this.$refs.courseNew.get_courses(this.selected_session,this.selected_group);
   // this.get_courses()
},
change_grp:function(){
    this.selected_session = ''
    this.$refs.courseNew.get_courses(this.selected_session,this.selected_group);
  //  this.get_courses()
},

add_course:function() {
    this.show_add_course = true
    document.querySelector('#myModalCourse').classList.add('is-active');
},
cancel_course:function() {
    this.show_add_course = false 
    document.querySelector('#myModalCourse').classList.remove('is-active');
},

toggle_course_view:function() {




    if (this.course_view == 'NEW') {this.course_view = 'LIST'}
    else {
        

        

// SET INITIAL SESSION/ANNEE
this.selected_session = moment().format('M')
if (this.selected_session < 5)  { this.selected_session = 'H'}
else if (this.selected_session < 8) { this.selected_session = 'E'}
else  { this.selected_session = 'A'}
this.selected_session += "-" +  moment().format('YY')
this.selected_group = ''

this.selected_groups = [] // HOLDS NEW COURSES
this.course_view = 'NEW'}

},







emit_load_start:function() {
    this.isLoading=true;
},
emit_load_end:function() {
    this.isLoading=false;
},

emit_list_click:function(session,gid, icr , rcs) {


// SCROLL TOP PAGE 
document.body.scrollTop = document.documentElement.scrollTop = 0;

this.comp_grp_icr = icr
this.comp_grp_rcs = rcs

    this.comp_grp_session = session
    this.comp_grp_group = gid
//
    
    //alert(gid)
},


load_student_summary:function() {
    this.isLoading=true;

// 1. GET PROGRAM COURSES
    var query = `SELECT DISTINCT MyMEQ_COUR.cour_ID,MyMEQ_PROGRAM.prog_ID, MyMEQ_PROGRAM.prog_TITRE_F, MyMEQ_PROGRAM.prog_TITRE_E, MyMEQ_COUR.cour_CODE, MyMEQ_COUR.cour_TITRE_F,   MyMEQ_COUR.cour_TITRE_E
                FROM  MyMEQ_PROGRAM INNER JOIN MyMEQ_RELATION ON MyMEQ_PROGRAM.prog_ID = MyMEQ_RELATION.prog_ID INNER JOIN MyMEQ_COUR ON MyMEQ_RELATION.cour_ID = MyMEQ_COUR.cour_ID 
                WHERE MyMEQ_PROGRAM.prog_ID = ` + this.programID + ` ORDER BY MyMEQ_COUR.cour_ID`
                
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
        this.data_program = res.data

        query=`SELECT     MyMEQ_COURSESTUDENT.cs_ID, MyMEQ_COURSESTUDENT.cs_MARK, MyMEQ_COURSESTUDENT.cs_REMARK, MyMEQ_GROUP.group_CODE, 
        MyMEQ_GROUP.group_SESS, MyMEQ_GROUP.group_ANN, MyMEQ_GROUP.group_AVG, group_datEND,MyMEQ_COUR.cour_ID, MyMEQ_COUR.cour_CODE, MyMEQ_COUR.cour_TITRE_F, MyMEQ_COUR.cour_TITRE_E, MyMEQ_GROUP.group_ID FROM MyMEQ_COURSESTUDENT INNER JOIN  MyMEQ_GROUP ON MyMEQ_COURSESTUDENT.group_ID = MyMEQ_GROUP.group_ID INNER JOIN  MyMEQ_COUR ON MyMEQ_GROUP.cour_ID = MyMEQ_COUR.cour_ID WHERE (MyMEQ_COURSESTUDENT.student_ID = ` + this.studentID + `) ORDER BY MyMEQ_GROUP.group_datSTART DESC`
        axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
        .then(res => { 
            this.data_student = res.data

// GET TRANSMISSION DATA FOR CHECKING WHATS DONE
query = `SELECT student_ID ,group_ID , myMEQ_FILE_TRAN.fileTran_PROCESSED, myMEQ_TRAN_MASTER.tran_bERROR, tran_TYPE 
FROM  myMEQ_TRAN_MASTER INNER JOIN myMEQ_FILE_TRAN ON myMEQ_TRAN_MASTER.fileTran_ID = myMEQ_FILE_TRAN.fileTran_ID 
WHERE 
(tran_TYPE = 'ICR' OR tran_TYPE = 'RCS')  AND 
student_ID = ` + this.studentID  + ` 
ORDER BY myMEQ_TRAN_MASTER.tran_ID DESC`
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => { 
    this.data_transmission = res.data

//console.log(res.data)


//this.comp_grp_session = 'A-19'// myUtilities.get_current_session_annee()
//this.comp_grp_group = -100

        this.isLoading=false;

}); // END AXIOS GET TRANSMISSION INFO        
}); // END AXIOS GET STUDENT INFO
}); // END AXIOS GET PROGRAMS


},
















// OLD -------- !!!!
student_courses:function() {
this.isLoading = true;
this.stud_course_data = []
this.stud_grps = []
this.stud_ponds = []

var self = this;
var sql;
sql=`SELECT     MyMEQ_COURSESTUDENT.cs_ID, MyMEQ_COURSESTUDENT.cs_MARK, MyMEQ_COURSESTUDENT.cs_REMARK, MyMEQ_GROUP.group_CODE, 
 MyMEQ_GROUP.group_SESS, MyMEQ_GROUP.group_ANN, MyMEQ_GROUP.group_AVG, MyMEQ_PROF_PONDERATION.ponderation_Desc, 
 MyMEQ_PROF_PONDERATION.ponderation_Percent, MyMEQ_PROF_PONDERATION.ponderation_AVG, MyMEQ_PROF_PONDERATION.ponderation_PUBLIC, 
 MyMEQ_PROF_NOTES.note_NOTE, MyMEQ_COUR.cour_CODE, MyMEQ_COUR.cour_TITRE_F, MyMEQ_COUR.cour_TITRE_E, MyMEQ_GROUP.group_ID,  MyMEQ_PROF_NOTES.ponderation_ID FROM MyMEQ_COURSESTUDENT INNER JOIN  MyMEQ_GROUP ON MyMEQ_COURSESTUDENT.group_ID = MyMEQ_GROUP.group_ID LEFT OUTER JOIN  MyMEQ_PROF_PONDERATION ON MyMEQ_GROUP.group_ID = MyMEQ_PROF_PONDERATION.group_ID LEFT OUTER JOIN  MyMEQ_PROF_NOTES ON MyMEQ_PROF_PONDERATION.ponderation_ID = MyMEQ_PROF_NOTES.ponderation_ID INNER JOIN  MyMEQ_COUR ON MyMEQ_GROUP.cour_ID = MyMEQ_COUR.cour_ID WHERE (MyMEQ_COURSESTUDENT.student_ID = ` + this.studentID + `) ORDER BY MyMEQ_GROUP.group_datSTART,MyMEQ_PROF_PONDERATION.ponderation_Order`
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => { 
   
    this.stud_course_data = res.data

    // GET DISTINCT GROUPS
    self.stud_course_data.filter(function(item){
    var i = self.stud_grps.findIndex(x => (x.group_ID == item.group_ID));
    if(i <= -1){
            self.stud_grps.push(item);
    }
    })

    // GET DISTINCT PONDS
    self.stud_course_data.filter(function(item){
    var i = self.stud_ponds.findIndex(x => (x.ponderation_ID == item.ponderation_ID));
    if(i <= -1){
            self.stud_ponds.push(item);
    }
    })

this.isLoading = false;
}); // END AXIOS


}, // END LOAD COURSES

// GENERATE A NEW ID! 
    randomKey:function() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });},

}, // END METHODS



} // END EXPORT
</script>